import { type NotificationContentType } from "@vega-api/generated/types/notificationContentType";
import { type NotificationResponse } from "@vega-api/generated/types/notificationResponse";

const bus = new EventTarget();

export const emitNotificationEvent = (payload: NotificationResponse) => {
  bus.dispatchEvent(new CustomEvent(payload.type, { detail: payload }));
};

export const subscribeNotificationEvent = (
  type: NotificationContentType,
  handler: (payload: NotificationResponse) => void,
) => {
  const listener = (event: Event) => {
    handler((event as CustomEvent<NotificationResponse>).detail);
  };

  bus.addEventListener(type, listener);

  return () => {
    bus.removeEventListener(type, listener);
  };
};
